<template>
  <div>
    <b-row class="mb-5">
      <b-col cols="12">
        <b-card
          style="background: transparent !important"
          class="card-diagnostic"
        >
          <template #header>
            <strong class="mb-0">Detalle de la calificación</strong>
          </template>
          <b-overlay :show="loading" rounded="sm">
            <template #overlay>
              <OverlayButton clase="overlay-md"> </OverlayButton>
            </template>
            <b-row>
              <b-col cols="6" class="mb-4">
                <Select
                  label="Tipo de siniestro"
                  name="claim_type"
                  v-model="formData.claim_type"
                  :options="optionsTypeLoss"
                  :value="formData.claim_type"
                  :required="true"
                  :disabled="isEdit || isBusy"
                />
              </b-col>
              <b-col cols="6" class="">
                <UploadFile
                  title="Adjunta el archivo de mejoria médica máxima"
                  @uploadFile="uploadFile"
                  :isBusy="isBusy"
                  :isEdit="isEdit"
                  :document="file1"
                  :id="'file-diag-1'"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6" class="mb-4">
                <Date
                  name="qualification_date"
                  label="Fecha calificación"
                  v-model="formData.qualification_date"
                  :value="formData.qualification_date"
                  :required="true"
                  :disabled="isEdit || isBusy"
                />
              </b-col>
              <b-col cols="6" />
              <b-col cols="6" class="mb-4">
                <Date
                  name="structuring_date"
                  label="Fecha estructuración"
                  v-model="formData.structuring_date"
                  :value="formData.structuring_date"
                  :required="true"
                  :disabled="isEdit || isBusy"
                />
              </b-col>
              <b-col cols="6" />
              <b-col cols="6" class="mb-4">
                <Select
                  label="Ente Responsable"
                  name="responsible_entity"
                  v-model="formData.responsible_entity"
                  :options="entities"
                  :value="formData.responsible_entity"
                  :required="true"
                  :disabled="isEdit || isBusy"
                />
              </b-col>
              <b-col cols="6" />
              <b-col cols="6" class="mb-4">
                <Select
                  label="Mejoria médicina máxima"
                  name="medical_improvement"
                  v-model="formData.medical_improvement"
                  :options="optionsMedicine"
                  :value="formData.medical_improvement"
                  :required="true"
                  :disabled="isEdit || isBusy"
                />
              </b-col>
              <b-col cols="6" />
              <b-col cols="6" class="mb-4">
                <Select
                  label="Estado"
                  name="qualification_status"
                  v-model="formData.qualification_status"
                  :options="optionsStatus"
                  :value="formData.qualification_status"
                  :required="true"
                  :disabled="isEdit || isBusy"
                />
              </b-col>
              <b-col cols="6" />
              <b-col cols="6" class="mb-4">
                <Textarea
                  label="Observaciones de la calificación"
                  name="qualification_observations"
                  :rows="'3'"
                  :value="formData.qualification_observations"
                  :required="true"
                  :disabled="isEdit || isBusy"
                  @input="
                    (event) =>
                      (formData.qualification_observations = event.target.value)
                  "
                />
              </b-col>
            </b-row>
          </b-overlay>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
const { Select, Date, Textarea } = useInputs();
import useInputs from "@/components/general/Inputs";
import UploadFile from "./UploadFile";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";

import { getInfoSelect } from "@/services/health-tracker/diagnostic/service";
export default {
  components: {
    Select,
    Date,
    Textarea,
    UploadFile,
    OverlayButton,
  },
  props: {
    entities: {
      type: Array,
      default: () => [],
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    record: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      optionsTypeLoss: [],
      optionsMedicine: [
        {
          id: "1",
          name: "Si",
        },
        {
          id: "2",
          name: "No",
        },
      ],
      optionsStatus: [],
      formData: {
        claim_type: null,
        qualification_date: "",
        structuring_date: "",
        responsible_entity: null,
        medical_improvement: null,
        qualification_status: null,
        qualification_observations: null,
        medical_improvement_file: null,
      },
      file1: null,
    };
  },
  watch: {
    formData: {
      handler() {
        this.$emit("changeForm", this.formData);
      },
      deep: true,
    },
    record() {
      const me = this;
      if (me.record) me.fillData();
    }
  },
  methods: {
    uploadFile(file) {
      const me = this;
      me.formData.medical_improvement_file = file;
    },
    async loadLoss() {
      const me = this;
      me.optionsTypeLoss = [];
      try {
        const { data } = await getInfoSelect("claim");
        data?.forEach((x) => {
          me.optionsTypeLoss.push({
            id: x.id,
            name: x.info,
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
    async loadStatus() {
      const me = this;
      me.optionsStatus = [];
      try {
        const { data } = await getInfoSelect("classification_status");
        data?.forEach((x) => {
          me.optionsStatus.push({
            id: x.id,
            name: x.info,
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
    fillData() {
      const me = this;
      me.formData.claim_type = {
        id: me.record?.claim_type_related?.id,
        name: me.record?.claim_type_related?.info,
      }
      me.formData.qualification_date = me.record?.qualification_date ? me.record?.qualification_date : "";
      me.formData.structuring_date = me.record?.structuring_date ? me.record?.structuring_date : "";
      me.formData.qualification_observations = me.record?.qualification_observations;
      me.formData.responsible_entity = {
        id: me.record?.responsible_entity_related?.id,
        name: me.record?.responsible_entity_related?.info,
      }
      me.formData.qualification_status = {
        id: me.record?.qualification_status_related?.id,
        name: me.record?.qualification_status_related?.info,
      }
      const medical = me.record?.medical_improvement ? "1" : "2";
      me.formData.medical_improvement = me.optionsMedicine.find(x => x.id == medical);
      me.file1 = me.record?.file?.medical_improvement_file ? me.record?.file?.medical_improvement_file : null;
    }
  },
  mounted() {
    const me = this;
    me.loadLoss();
    me.loadStatus();
  },
};
</script>

<style lang="css">
.card-diagnostic .card-header {
  background: #f5f5f5 !important;
}
</style>
